import { userModelSelector, guestModeSelector } from "../../../../state/selectors/userModel";
import { signInMenuActivatedSelector } from "../../../../state/selectors/navbarToggle";
import { userHostModelSelector } from "../../../../state/selectors/userHostModel";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ColorTheme } from "../../../../components/globaStyledComponents/globalStyledComponentsStyling";
import {
    NavbarProfileImage,
    NavbarProfileNotificationWrapper,
    NavbarProfileNotificationImage,
    NavbarProfileImageButton,
    NavbarDesktopListYourPlaceWrapper,
    NavbarRightContentWrapper,
    NavbarCreateListingIcon,
} from "../navbarStyling";
import { useState, useEffect, useCallback } from "react";
import ContinueBtn from "../../../btn/continueBtn/continueBtn";
import NavbarMenu from "../navbarDropDownMenu";
import { directToAfterLoginSelector } from "../../../../state/selectors/directToAfterLogin";
import constructOptimisedProtectedImageUrl from "../../../../utils/imageOptimisation/constructOptimisedProtectedImageUrl";
import NotificationDropDown from "../../notifications/notifications";
import { searchFiltersSelector } from "../../../../state/selectors/searchQuery";
import { isUserChangePriceSelector } from "../../../../state/selectors/isUserChangePrice";
import { isHomeAISearchVisibleState } from "../../../../state/atoms/homeAISearchVisible";

interface LocationBasedComponentsProps {
    navbarMenu: boolean;
    setNavbarMenu: React.Dispatch<React.SetStateAction<boolean>>;
    setNotificationsPopup: React.Dispatch<React.SetStateAction<boolean>>;
    setNavbarSearchMenuActivated: React.Dispatch<React.SetStateAction<boolean>>;
    notificationsPopup: boolean;
    isCurrencyPopupOpen: boolean;
    setIsCurrencyPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isHomeScrolled?: boolean;
}

export default function LocationBasedComponents({ navbarMenu, setNavbarMenu, setNotificationsPopup, setNavbarSearchMenuActivated, notificationsPopup, isCurrencyPopupOpen, setIsCurrencyPopupOpen, isHomeScrolled }: LocationBasedComponentsProps) {
    const navigate = useNavigate();
    const location = useLocation();

    const [userModel] = useRecoilState(userModelSelector);
    const [userHostModel] = useRecoilState(userHostModelSelector);
    const [guestMode] = useRecoilState(guestModeSelector);
    const [, setSignInMenuActivated] = useRecoilState(signInMenuActivatedSelector);
    const [, setDirectToAfterLogin] = useRecoilState(directToAfterLoginSelector);

    const [isContinueBtnLoading, setIsContinueBtnLoading] = useState(false);
    const [profilePic, setProfilePic] = useState("https://d292awxalydr86.cloudfront.net/Settings+page/Profile+photo+placeholder.png");
    const [hideBtn, setHideBtn] = useState(true);

    const [searchFilters, setSearchFilters] = useRecoilState(searchFiltersSelector);
    const [, setIsUserChangePrice] = useRecoilState(isUserChangePriceSelector);

    const [isHomeAISearchVisible, setIsHomeAISearchVisible] = useRecoilState(isHomeAISearchVisibleState);

    const createListingBtnOnClick = async () => {
        if (userHostModel) {
            setIsContinueBtnLoading(true);
            navigate(`/create-listing/${userHostModel && userHostModel.id}`);
        } else {
            setSignInMenuActivated(true);
            setDirectToAfterLogin("create-listing");
        }
    };
    
    const handleScroll = useCallback(() => {
        if (location.pathname === "/") {
            // if (!isHomeAISearchVisible) {
            //     document.getElementById("navbar-wrapper")?.style.setProperty("background-color", "white");
            //     document.getElementById("navbar")?.style.setProperty("background-color", "white");
            // } else {
            //     // document.getElementById("navbar-wrapper")?.style.setProperty("background-color", "unset");
            //     // document.getElementById("navbar")?.style.setProperty("background-color", "unset");
            // }
        } else if (location.pathname.includes("list-your-place")) {
            let mainBtn = document.getElementById("hostLandingPageMainBtn");
            if (mainBtn) {
                if (mainBtn.getBoundingClientRect().top <= 50) {
                    setHideBtn(false);
                } else {
                    setHideBtn(true);
                }
            }
        } else {
            // FIXME: Remove this may cause style issues, help me.
            // document.getElementById("navbar-wrapper")?.style.setProperty("background-color", "white");
            // document.getElementById("navbar")?.style.setProperty("background-color", "white");
        }
    }, [location.pathname]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll, location.pathname]);

    useEffect(() => {
        if (userModel && userModel.profilePicture && userModel.identityID) {
            const profilePic = constructOptimisedProtectedImageUrl(userModel.profilePicture, userModel.identityID, 100);
            setProfilePic(profilePic);
        } else {
            setProfilePic("https://d292awxalydr86.cloudfront.net/Settings+page/Profile+photo+placeholder.png");
        }
    }, [userModel]);

    const renderListYourPlaceOrSwitchToStaying = () => {
        if (userModel) {
            if (!guestMode) {
                return (
                    <NavbarDesktopListYourPlaceWrapper
                        location={location.pathname}
                        isHomeAISearchVisible={isHomeAISearchVisible}
                        onClick={() => {
                            const searchFiltersCopy = JSON.parse(JSON.stringify(searchFilters));
                            // category removed
                            setSearchFilters(searchFiltersCopy);
                            setIsUserChangePrice(false);
                            navigate("/");
                        }}
                    >
                        Switch to staying
                    </NavbarDesktopListYourPlaceWrapper>
                );
            }
        }
        if (userHostModel && userHostModel.listingModelNumber && userHostModel.listingModelNumber > 0 && !location.pathname.includes("/list-your-place")) {
            return (
                <NavbarDesktopListYourPlaceWrapper
                    location={location.pathname}
                    isHomeAISearchVisible={isHomeAISearchVisible}
                    isWhiteOnHome={location.pathname === "/" && !isHomeScrolled}
                    onClick={() => {
                        setNavbarSearchMenuActivated(false);
                        setNavbarMenu(false);
                        navigate("/dashboard");
                    }}
                >
                    Switch to hosting
                </NavbarDesktopListYourPlaceWrapper>
            );
        }
        if (location.pathname.includes("/list-your-place") && window.innerWidth < 768) {
            return null;
        }
        return (
            <NavbarDesktopListYourPlaceWrapper
                location={location.pathname}
                isHomeAISearchVisible={isHomeAISearchVisible}
                isWhiteOnHome={location.pathname === "/" && !isHomeScrolled}
                onClick={(e) => {
                    e.stopPropagation();
                    setNavbarSearchMenuActivated(false);
                    setNavbarMenu(false);
                    setIsHomeAISearchVisible(true);
                    navigate("/list-your-place");
                }}
            >
                List your place
            </NavbarDesktopListYourPlaceWrapper>
        );
    };

    if (location.pathname.includes("/stay")) return null;
    if (location.pathname.includes("/invite")) return null;
    if (location.pathname.includes("/search") && window.innerWidth >= 1024) return null;
    if (location.pathname.includes("/list-your-place") && window.innerWidth >= 768) {
        if (hideBtn) {
            return null;
        } else {
            return (
                <ContinueBtn
                    isLoading={isContinueBtnLoading}
                    background={"black"}
                    disabled={isContinueBtnLoading}
                    style={{ width: "unset", padding: "0 24px 0 20px", marginTop: "0", height: "48px", fontSize: "16px", borderRadius: "90px" }}
                    continueType="button"
                    onClick={createListingBtnOnClick}
                >
                    <NavbarCreateListingIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="10.5" width="3" height="24" rx="1.5" fill={ColorTheme.White.color} />
                        <rect y="13.5" width="3" height="24" rx="1.5" transform="rotate(-90 0 13.5)" fill={ColorTheme.White.color} />
                    </NavbarCreateListingIcon>
                    Create a listing
                </ContinueBtn>
            );
        }
    }
    return (
            <NavbarRightContentWrapper pathname={location.pathname}>
            {renderListYourPlaceOrSwitchToStaying()}
            <NavbarProfileNotificationWrapper>
                <svg 
                    onClick={() => {
                        setNavbarSearchMenuActivated(false);
                        setNavbarMenu(false);
                        if (userModel) {
                            setNotificationsPopup(true);
                        } else {
                            setSignInMenuActivated(true);
                        }
                    }}
                    width="24" 
                    height="24" 
                    viewBox="0 0 240 240"
                    style={{ cursor: 'pointer' }}
                >
                    <g transform="translate(0.000000,240.000000) scale(0.100000,-0.100000)" fill={(location.pathname.includes("/collection") || (location.pathname === "/" && !isHomeScrolled)) ? "#FFFFFF" : "#000000"} stroke="none">
                        <path d="M1033 2164 c-244 -53 -464 -237 -558 -465 -44 -108 -55 -175 -65
                        -394 -14 -310 -44 -483 -110 -623 -35 -76 -37 -91 -10 -120 20 -22 26 -22 304
                        -22 l283 0 7 -46 c9 -72 62 -160 121 -204 72 -53 109 -65 200 -65 72 0 86 3
                        143 34 91 49 152 136 167 234 l7 47 282 0 c282 0 283 0 304 23 12 13 22 30 22
                        37 0 8 -18 50 -39 95 -65 133 -88 265 -101 595 -10 235 -20 298 -65 409 -95
                        232 -315 413 -565 466 -87 18 -243 18 -327 -1z m300 -140 c240 -53 439 -245
                        491 -476 8 -35 17 -137 21 -228 11 -286 32 -451 81 -617 l6 -23 -736 0 c-405
                        0 -736 1 -736 3 0 1 9 34 20 72 39 134 60 288 70 500 6 116 15 237 21 270 33
                        184 167 357 343 445 138 68 275 86 419 54z m81 -1521 c-22 -122 -87 -176 -216
                        -176 -122 0 -195 58 -213 171 l-7 42 222 0 221 0 -7 -37z"/>
                    </g>
                </svg>
                {/* <NavbarMenuRedDot style={{ margin: "0", position: "absolute", right: "4px", top: "4px" }} /> */}
            </NavbarProfileNotificationWrapper>

            {window.innerWidth >= 768 && (
                <NavbarProfileImageButton>
                    <NavbarProfileImage
                        src={profilePic}
                        alt="profile picture"
                        onClick={() => {
                            setNotificationsPopup(false);
                            setNavbarSearchMenuActivated(false);
                            setNavbarMenu(true);
                        }}
                    />
                    {navbarMenu && <NavbarMenu closeNavbarMenu={() => setNavbarMenu(false)} navbarMenu={navbarMenu} setNavbarMenu={setNavbarMenu} isCurrencyPopupOpen={isCurrencyPopupOpen} setIsCurrencyPopupOpen={setIsCurrencyPopupOpen} />}
                    {notificationsPopup && (
                        <NotificationDropDown notificationsPopup={notificationsPopup} closeNotificationDropDown={() => setNotificationsPopup(false)} setNotificationsPopup={setNotificationsPopup} />
                    )}
                </NavbarProfileImageButton>
            )}
        </NavbarRightContentWrapper>
    );
}
